import { PoolFilters } from '@/types/pool';
import { apiClient } from './apiClient';

export type FavoriteFilter = {
  id: number;
  name: string;
  filters: PoolFilters;
  notifications_enabled: boolean;
  created_at: string;
  updated_at: string;
};

type GetFavoriteFiltersResponse = {
  filters: FavoriteFilter[];
};

export const favoriteFiltersService = {
  async getFavoriteFilters() {
    return apiClient<GetFavoriteFiltersResponse>('/api/filters');
  },

  async createFavoriteFilter(name: string, filters: PoolFilters, notifications_enabled: boolean) {
    return apiClient<FavoriteFilter>('/api/filters', {
      method: 'POST',
      body: { name, filters, notifications_enabled },
    });
  },

  async updateFavoriteFilter(filterId: number, name: string, filters: PoolFilters) {
    return apiClient<FavoriteFilter>(`/api/filters/${filterId}`, {
      method: 'PUT',
      body: { name, filters },
    });
  },

  async deleteFavoriteFilter(filterId: number) {
    return apiClient(`/api/filters/${filterId}`, {
      method: 'DELETE',
    });
  },
};
